// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorScreen_wrapper__020yW","image":"ErrorScreen_image__0SWRH","text":"ErrorScreen_text__6SuRv"};